module.exports = __webpack_public_path__ + "media/images/fallback/product_panoramic-7dee16ef980c6d9bf39fe6f2be244b0d.webp";